export default "__VITE_ASSET__DHrBacIu__"